(() => {
  const message = '购物车与下单功能已关闭，请通过应用权限页面提交申请。';
  // Shopify's cart endpoints commonly end in .js (for example /cart/add.js).
  // Match them with or without the extension, including locale-prefixed paths.
  const blockedPath = /(?:^|\/)(?:cart\/(?:add|update|change|clear)(?:\.(?:js|json))?|checkout)(?:\/|$)/i;
  const accountPath = /\/(?:account|customer-account)(?:[/?#]|$)/i;
  const logoutPath = /\/(?:account\/logout|customer_authentication\/logout)(?:[/?#]|$)/i;
  const rootPath = window.Shopify?.routes?.root || '/';
  const isBlockedCommerceUrl = (value) => {
    const candidate = String(value || '').trim();
    if (!candidate) return false;

    try {
      return blockedPath.test(new URL(candidate, window.location.href).pathname);
    } catch {
      return blockedPath.test(candidate);
    }
  };
  const logoutStorageKey = 'axewood_logout_redirect';
  const defaultLogoutPath = '/pages/axewood-service-center';
  let toast;
  let toastTimer;

  if (
    !document.documentElement.classList.contains('shopify-design-mode') &&
    accountPath.test(window.location.pathname) &&
    !logoutPath.test(window.location.pathname)
  ) {
    window.location.replace(rootPath);
    return;
  }

  if (
    !document.documentElement.classList.contains('shopify-design-mode') &&
    /(?:^|\/)checkout(?:\/|$)/i.test(window.location.pathname)
  ) {
    window.location.replace(`${rootPath}pages/axewood-service-center`);
    return;
  }

  const getSafeInternalPath = (value) => {
    const candidate = String(value || '').trim();
    if (!candidate.startsWith('/') || candidate.startsWith('//')) return defaultLogoutPath;

    try {
      const url = new URL(candidate, window.location.origin);
      if (url.origin !== window.location.origin) return defaultLogoutPath;
      return `${url.pathname}${url.search}${url.hash}`;
    } catch {
      return defaultLogoutPath;
    }
  };

  const readLogoutPayload = (value) => {
    if (!value) return null;

    try {
      const payload = JSON.parse(value);
      const age = Date.now() - Number(payload?.timestamp || 0);
      if (!payload || !Number.isFinite(age) || age < 0 || age > 20000) return null;
      return payload;
    } catch {
      return null;
    }
  };

  const getStoredLogoutPayload = () => {
    const values = [];

    try {
      values.push(window.sessionStorage.getItem(logoutStorageKey));
    } catch {
      // Session storage may be unavailable in privacy-restricted browsers.
    }
    try {
      values.push(window.localStorage.getItem(logoutStorageKey));
    } catch {
      // Local storage may be unavailable in privacy-restricted browsers.
    }

    try {
      const cookieValue = document.cookie
        .split('; ')
        .map((part) => part.split('='))
        .find(([name]) => name === logoutStorageKey)
        ?.slice(1)
        .join('=');
      if (cookieValue) values.push(decodeURIComponent(cookieValue));
    } catch {
      // Cookies may be unavailable in privacy-restricted browsers.
    }

    return values
      .map(readLogoutPayload)
      .filter(Boolean)
      .sort((first, second) => Number(second.timestamp) - Number(first.timestamp))[0];
  };

  const clearStoredLogoutPayload = () => {
    try {
      window.sessionStorage.removeItem(logoutStorageKey);
    } catch {
      // Session storage may be unavailable in privacy-restricted browsers.
    }
    try {
      window.localStorage.removeItem(logoutStorageKey);
    } catch {
      // Local storage may be unavailable in privacy-restricted browsers.
    }
    try {
      document.cookie = `${logoutStorageKey}=; Max-Age=0; Path=/; SameSite=Lax`;
    } catch {
      // Cookies may be unavailable in privacy-restricted browsers.
    }
  };

  const redirectAfterLogout = () => {
    if (logoutPath.test(window.location.pathname)) return;

    const payload = getStoredLogoutPayload();
    if (!payload) return;
    clearStoredLogoutPayload();

    const targetUrl = new URL(getSafeInternalPath(payload.path), window.location.origin);
    if (targetUrl.pathname === window.location.pathname && targetUrl.search === window.location.search) return;
    window.location.replace(targetUrl.href);
  };

  redirectAfterLogout();

  const showNotice = () => {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ax-commerce-disabled-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => {
      toast?.classList.remove('is-visible');
    }, 3600);
  };

  const isAccessRequest = (element) =>
    Boolean(element?.closest('.axewood-access-request, .axewood-service-center, .axewood-manuals, .axewood-apk-downloads'));

  if (typeof HTMLFormElement !== 'undefined') {
    const originalSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (isBlockedCommerceUrl(this.action)) {
        showNotice();
        return;
      }
      return originalSubmit.apply(this, arguments);
    };
  }

  const isBlockedControl = (element) => {
    if (!(element instanceof Element) || isAccessRequest(element)) return false;

    const form = element.closest('form');
    const formAction = form?.getAttribute('action') || '';
    const href = element.closest('a')?.getAttribute('href') || '';
    const name = element.getAttribute('name') || '';

    return (
      isBlockedCommerceUrl(formAction) ||
      isBlockedCommerceUrl(href) ||
      name === 'add' ||
      name === 'checkout' ||
      element.matches('.quick-add, .quick-add__button, [data-testid="cart-drawer-trigger"]')
    );
  };

  const isAccountControl = (element) => {
    if (!(element instanceof Element)) return false;

    const href = element.closest('a')?.getAttribute('href') || '';
    try {
      return accountPath.test(new URL(href, window.location.href).pathname);
    } catch {
      return false;
    }
  };

  const isLogoutControl = (element) => {
    if (!(element instanceof Element)) return false;
    if (element.closest('[data-axewood-logout]')) return true;

    const href = element.closest('a')?.getAttribute('href') || '';
    try {
      const path = new URL(href, window.location.href).pathname;
      return /\/account\/logout(?:\/|$)/i.test(path) || /\/customer_authentication\/logout(?:\/|$)/i.test(path);
    } catch {
      return false;
    }
  };

  const rememberLogoutTarget = (element) => {
    const logoutLink = element?.closest?.('[data-axewood-logout]');
    const targetPath = getSafeInternalPath(logoutLink?.getAttribute('data-axewood-logout-return'));
    const payload = JSON.stringify({ path: targetPath, timestamp: Date.now() });

    try {
      window.sessionStorage.setItem(logoutStorageKey, payload);
    } catch {
      // Session storage may be unavailable in privacy-restricted browsers.
    }

    try {
      window.localStorage.setItem(logoutStorageKey, payload);
    } catch {
      // Local storage may be unavailable in privacy-restricted browsers.
    }

    try {
      document.cookie = `${logoutStorageKey}=${encodeURIComponent(payload)}; Max-Age=20; Path=/; SameSite=Lax`;
    } catch {
      // Cookies may be unavailable in privacy-restricted browsers.
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      if (isLogoutControl(event.target)) {
        rememberLogoutTarget(event.target);
        return;
      }

      if (isAccountControl(event.target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(rootPath);
        return;
      }

      if (!isBlockedControl(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showNotice();
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      if (!isBlockedControl(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showNotice();
    },
    true
  );

  const originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      const requestUrl = typeof input === 'string' ? input : input?.url;
      let url;

      try {
        url = new URL(requestUrl || '', window.location.href);
      } catch {
        return originalFetch.call(this, input, init);
      }

      if (!isBlockedCommerceUrl(url.pathname)) {
        return originalFetch.call(this, input, init);
      }

      showNotice();
      return Promise.resolve(
        new Response(JSON.stringify({ error: message }), {
          status: 403,
          headers: { 'Content-Type': 'application/json' },
        })
      );
    };
  }

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__axewoodCommerceDisabled = isBlockedCommerceUrl(url);
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__axewoodCommerceDisabled) {
      showNotice();
      return;
    }
    return originalSend.apply(this, arguments);
  };
})();
